import React from 'react';
import type { FeedbackType } from '../../types/messages';
import { updateAiMessageFeedback } from '../../api/messages';
import FeedbackButtons from '../feedback/FeedbackButtons';

type Props = {
  messageId: string;
  tripId: string;
  currentFeedback: FeedbackType | null;
  feedbackCommentSubmitted: boolean;
  onFeedbackUpdate: (messageId: string, feedback: FeedbackType, commentSubmitted: boolean) => void;
};

const PROMPT_TEXTS: Record<FeedbackType, string> = {
  good: 'よろしければ、サービス品質向上のために、よかった点をお聞かせください',
  bad: 'よろしければ、サービス品質向上のために、どのような返答が望ましかったかをお聞かせください'
};

const AiMessageFeedback = ({
  messageId,
  tripId,
  currentFeedback,
  feedbackCommentSubmitted,
  onFeedbackUpdate
}: Props) => {
  const handleSubmit = async (feedbackType: FeedbackType, comment?: string) => {
    const result = await updateAiMessageFeedback(tripId, messageId, feedbackType, comment);
    onFeedbackUpdate(messageId, feedbackType, result.feedback_comment_submitted);
  };

  return (
    <FeedbackButtons
      currentFeedback={currentFeedback}
      commentSubmitted={feedbackCommentSubmitted}
      promptTexts={PROMPT_TEXTS}
      onSubmit={handleSubmit}
    />
  );
};

export default AiMessageFeedback;
